import { LogError } from "./logger"

export function logApolloError(label, error) {
  LogError(label, error)

  if (error?.graphQLErrors?.length) {
    LogError(`${label} graphQLErrors:`, error.graphQLErrors)
  }

  if (error?.networkError) {
    LogError(`${label} networkError:`, error.networkError)
  }

  if (error?.networkError?.result) {
    LogError(`${label} networkError.result:`, error.networkError.result)
  }
}